import {
  cellKey,
  inFocus,
  isSquareCell,
} from "@/lib/tool-kit/worksheets/charts";

const EXACT_COLOR = {
  printColorAdjust: "exact",
  WebkitPrintColorAdjust: "exact",
} as const;
const GRID = "border border-neutral-700";

/** A multiplication table with factors along the top and left. */
export function ChartTable({
  factors,
  blanks,
  focus,
  squares,
  fontPoints,
  label,
  corner,
}: {
  factors: readonly number[];
  /** Cells to leave empty; null shows every product. */
  blanks: ReadonlySet<string> | null;
  focus: number | null;
  squares: boolean;
  fontPoints: number;
  label: string;
  corner: string;
}) {
  return (
    <table
      aria-label={label}
      className="w-full table-fixed border-collapse text-center font-mono tabular-nums"
      style={{ fontSize: `${fontPoints}pt`, ...EXACT_COLOR }}
    >
      <thead>
        <tr>
          <th className={`${GRID} bg-neutral-400 py-[0.3em]`} scope="col">
            {corner}
          </th>
          {factors.map((column) => (
            <th
              className={`${GRID} py-[0.3em] ${focus === column ? "bg-neutral-500 text-white" : "bg-neutral-300"}`}
              key={column}
              scope="col"
            >
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {factors.map((row) => (
          <tr key={row}>
            <th
              className={`${GRID} py-[0.3em] ${focus === row ? "bg-neutral-500 text-white" : "bg-neutral-300"}`}
              scope="row"
            >
              {row}
            </th>
            {factors.map((column) => {
              let shade = "";
              if (inFocus(row, column, focus)) {
                shade = "bg-neutral-200";
              } else if (squares && isSquareCell(row, column)) {
                shade = "bg-neutral-100";
              }
              const bold = squares && isSquareCell(row, column);
              return (
                <td
                  className={`${GRID} py-[0.3em] ${shade} ${bold ? "font-bold" : ""}`}
                  key={column}
                >
                  {blanks?.has(cellKey(row, column)) ? "" : row * column}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
